import React from 'react';
import { Switch, Route } from 'react-router';
import { Home } from './pages';

const Hydrated = () => {
  return (
    <Switch>
      <Route component={Home} />
    </Switch>
  );
};

export default Hydrated;
